import {
    OBTENER_PEDIDOS_ACTIVO,
    OBTENER_PEDIDOS_ACTIVO_ERROR,
    FINALIZAR_PEDIDO_ERROR,
    FINALIZAR_PEDIDO,
    DESPACHAR_PEDIDO,
    DESPACHAR_PEDIDO_ERROR,
    RESET_STATE,
    ELIMINAR_PEDIDO, 
    ELIMINAR_PEDIDO_ERROR,
    DIALOG,
    ELIMINAR_MENU_PEDIDO,
    ELIMINAR_MENU_PEDIDO_ERROR,
    AGREGAR_MENU_PEDIDO,
    AGREGAR_MENU_PEDIDO_ERROR,
    AGREGAR_PEDIDO,
    AGREGAR_PEDIDO_ERROR,
    EDITAR_CARTA,
    EDITAR_CARTA_ERROR,
    AGREGAR_CARTA,
    AGREGAR_CARTA_ERROR,
    ELIMINAR_ITEM,
    ELIMINAR_ITEM_ERROR,
    SUBIR_CARTA,
    FACTURACION
 

            } from '../../types/index'

export default (state,action ) => {
    switch (action.type) {
        case FACTURACION : 
            return {
                ...state,
                error : false,
                mensaje : null ,
                historial : action.payload
            }
        case OBTENER_PEDIDOS_ACTIVO :
            return {
                ...state,
                pedidos : action.payload
            }
        case ELIMINAR_ITEM_ERROR :
        case AGREGAR_CARTA_ERROR:
        case EDITAR_CARTA_ERROR:
        case AGREGAR_PEDIDO_ERROR:
        case AGREGAR_MENU_PEDIDO_ERROR:
        case ELIMINAR_MENU_PEDIDO_ERROR:
        case ELIMINAR_PEDIDO_ERROR:
        case FINALIZAR_PEDIDO_ERROR:   
        case DESPACHAR_PEDIDO_ERROR:    
        case OBTENER_PEDIDOS_ACTIVO_ERROR :
            return {
                ...state,
                mensaje : action.payload,
                error: true,
                error_pedido:true
            }
        case SUBIR_CARTA:
        case ELIMINAR_ITEM :
        case AGREGAR_CARTA:
        case EDITAR_CARTA:
        case AGREGAR_PEDIDO:
        case AGREGAR_MENU_PEDIDO:
        case ELIMINAR_MENU_PEDIDO:
        case ELIMINAR_PEDIDO:
        case DESPACHAR_PEDIDO:
        case FINALIZAR_PEDIDO:
            return {
                ...state,
                mensaje : action.payload,
                open: false,
                error: false
            }
        case RESET_STATE :
            return {
                ...state,
                mensaje : null,
                error : null,
                error_pedido: null
            }
        case DIALOG : 
            return {
                ...state,
                open : action.payload
            }
    
        default:
            break;
    }
}